const locale = {skip:'scheduling_ouwn_publication_tour.skip_btn' ,next:'scheduling_ouwn_publication_tour.next_btn', close:'scheduling_ouwn_publication_tour.close_btn', back:'scheduling_ouwn_publication_tour.back_btn', last:'scheduling_ouwn_publication_tour.last_btn'}

export const SchedulingPostTourGuide = [
  {
    target: '#social-medias-selector',
    content:'scheduling_ouwn_publication_tour.step1',
    disableBeacon:true,
    placement:'right',
    locale
  },
  {
    target: '#social-medias-selector-item',
    content:'scheduling_ouwn_publication_tour.step2',
    disableBeacon:true,
    placement:'left',
    locale
  },
  
]

export const AddImageToPostTourGuide = [
  {
    target: '#image-post-input',
    content:'scheduling_ouwn_publication_tour.step3',
    disableBeacon:true,
    placement:'auto',
    locale
  },
  {
    target: '#subtitle-field',
    content:'scheduling_ouwn_publication_tour.step4',
    disableBeacon:true,
    placement:'bottom',
    locale
  },
  {
    target: '#scheduling-calendar',
    content:'scheduling_ouwn_publication_tour.step5',
    disableBeacon:true,
    placement:'auto',
    locale
  },
  {
    target: '#scheduling-time',
    content:'scheduling_ouwn_publication_tour.step6',
    disableBeacon:true,
    placement:'auto',
    locale
  },{
    target: '#scheduling-switch-component',
    content:'scheduling_ouwn_publication_tour.step7',
    disableBeacon:true,
    placement:'auto',
    locale
  },
  

]

export const AfterUplodaImage = [
  {
    target: '#social-media-config',
    content:'scheduling_ouwn_publication_tour.step8',
    disableBeacon:true,
    placement:'auto',
    locale
  },
  {
    target:'#next-step-btn',
    content:'scheduling_ouwn_publication_tour.step9',
    disableBeacon:true,
    placement:'left',
    disableOverlayClose:true,
    locale

  },
]